//frontend/src/admin/ClientServicesManagement.js
import React, { useState, useEffect } from 'react';
import { 
  FaPlus, FaEdit, FaTrash, FaSave, FaTimes, FaTruck,
  FaShippingFast, FaDollarSign, FaCheckCircle, FaClock,
  FaBoxOpen, FaPhone, FaGlobe, FaUsers, FaStar,
  FaPlane, FaShip, FaTrain, FaWarehouse, FaArrowUp, FaArrowDown
} from 'react-icons/fa';
import axiosInstance from '../axios';
import '../styles/admin.css';

const ClientServicesManagement = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editingService, setEditingService] = useState(null);
  const [formData, setFormData] = useState({
    service_name: '',
    description: '',
    features: [''],
    icon_name: 'FaBoxOpen',
    icon_color: 'blue',
    badge_text: '',
    is_featured: false,
    display_order: 0,
    is_active: true
  });

  // Icon сонголтууд
  const iconOptions = [
    { name: 'FaShippingFast', label: 'Хурдан', component: <FaShippingFast /> },
    { name: 'FaBoxOpen', label: 'Ачаа', component: <FaBoxOpen /> },
    { name: 'FaGlobe', label: 'Олон улс', component: <FaGlobe /> },
    { name: 'FaTruck', label: 'Тээвэр', component: <FaTruck /> },
    { name: 'FaPlane', label: 'Агаар', component: <FaPlane /> },
    { name: 'FaShip', label: 'Усан', component: <FaShip /> },
    { name: 'FaTrain', label: 'Төмөр зам', component: <FaTrain /> },
    { name: 'FaWarehouse', label: 'Агуулах', component: <FaWarehouse /> }
  ];

  // Өнгөний сонголтууд
  const colorOptions = [
    { value: 'blue', label: 'Цэнхэр', class: 'bg-blue-500' },
    { value: 'green', label: 'Ногоон', class: 'bg-green-500' },
    { value: 'purple', label: 'Нил ягаан', class: 'bg-purple-500' },
    { value: 'orange', label: 'Улбар шар', class: 'bg-orange-500' },
    { value: 'red', label: 'Улаан', class: 'bg-red-500' },
    { value: 'yellow', label: 'Шар', class: 'bg-yellow-500' },
    { value: 'pink', label: 'Ягаан', class: 'bg-pink-500' },
    { value: 'indigo', label: 'Хөх', class: 'bg-indigo-500' }
  ];

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get('/api/client/services');
      if (response.data.success) {
        setServices(response.data.data || []);
      }
    } catch (error) {
      console.error('Fetch services error:', error);
      alert('Үйлчилгээ татахад алдаа гарлаа');
    } finally {
      setLoading(false);
    }
  };

  // Feature нэмэх
  const addFeature = () => {
    setFormData({
      ...formData,
      features: [...formData.features, '']
    });
  };

  // Feature устгах
  const removeFeature = (index) => {
    const newFeatures = formData.features.filter((_, i) => i !== index);
    setFormData({
      ...formData,
      features: newFeatures.length > 0 ? newFeatures : ['']
    });
  };

  // Feature өөрчлөх
  const updateFeature = (index, value) => {
    const newFeatures = [...formData.features];
    newFeatures[index] = value;
    setFormData({
      ...formData,
      features: newFeatures
    });
  };

  // Feature дээш шилжүүлэх
  const moveFeatureUp = (index) => {
    if (index === 0) return;
    const newFeatures = [...formData.features];
    [newFeatures[index - 1], newFeatures[index]] = [newFeatures[index], newFeatures[index - 1]];
    setFormData({ ...formData, features: newFeatures });
  };

  // Feature доош шилжүүлэх
  const moveFeatureDown = (index) => {
    if (index === formData.features.length - 1) return;
    const newFeatures = [...formData.features];
    [newFeatures[index], newFeatures[index + 1]] = [newFeatures[index + 1], newFeatures[index]];
    setFormData({ ...formData, features: newFeatures });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.service_name.trim()) {
      alert('Үйлчилгээний нэр оруулна уу');
      return;
    }

    // Хоосон features устгах
    const cleanedFeatures = formData.features.filter(f => f.trim() !== '');
    if (cleanedFeatures.length === 0) {
      alert('Хамгийн багадаа 1 онцлог шинж чанар оруулна уу');
      return;
    }

    setLoading(true);
    
    try {
      const submitData = {
        ...formData,
        features: cleanedFeatures
      };

      if (editingService) {
        await axiosInstance.put(`/api/client/services/${editingService.id}`, submitData);
        alert('✅ Үйлчилгээ амжилттай шинэчлэгдлээ');
      } else {
        await axiosInstance.post('/api/client/services', submitData);
        alert('✅ Үйлчилгээ амжилттай үүсгэгдлээ');
      }
      
      setShowModal(false);
      resetForm();
      fetchServices();
    } catch (error) {
      console.error('Save service error:', error);
      alert('❌ ' + (error.response?.data?.msg || 'Алдаа гарлаа'));
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (service) => {
    setEditingService(service);
    setFormData({
      service_name: service.service_name,
      description: service.description || '',
      features: service.features && service.features.length > 0 ? service.features : [''],
      icon_name: service.icon_name || 'FaBoxOpen',
      icon_color: service.icon_color || 'blue',
      badge_text: service.badge_text || '',
      is_featured: service.is_featured,
      display_order: service.display_order || 0,
      is_active: service.is_active
    });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Энэ үйлчилгээг устгахдаа итгэлтэй байна уу?')) return;
    
    setLoading(true);
    try {
      await axiosInstance.delete(`/api/client/services/${id}`);
      alert('✅ Үйлчилгээ амжилттай устгагдлаа');
      fetchServices();
    } catch (error) {
      console.error('Delete service error:', error);
      alert('❌ ' + (error.response?.data?.msg || 'Устгахад алдаа гарлаа'));
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setEditingService(null);
    setFormData({
      service_name: '',
      description: '',
      features: [''],
      icon_name: 'FaBoxOpen',
      icon_color: 'blue',
      badge_text: '',
      is_featured: false,
      display_order: 0,
      is_active: true
    });
  };

  // Icon харуулах
  const getIconComponent = (iconName) => {
    const icon = iconOptions.find(opt => opt.name === iconName);
    return icon ? icon.component : <FaBoxOpen />;
  };

  // Өнгөний class
  const getColorClass = (color) => {
    const colorOption = colorOptions.find(opt => opt.value === color);
    return colorOption ? colorOption.class : 'bg-blue-500';
  };

  // Text color class
  const getTextColorClass = (color) => {
    const colorMap = {
      blue: 'text-blue-600',
      green: 'text-green-600',
      purple: 'text-purple-600',
      orange: 'text-orange-600',
      red: 'text-red-600',
      yellow: 'text-yellow-600',
      pink: 'text-pink-600',
      indigo: 'text-indigo-600'
    };
    return colorMap[color] || 'text-blue-600';
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-6">
      <div className="mb-6 flex justify-between items-center">
        <div>
          <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2 flex items-center">
            <FaTruck className="mr-3 text-blue-600" />
            Үйлчилгээ удирдлага
          </h1>
          <p className="text-sm text-gray-600">
            Нүүр хуудасны "Ачаа тээврийн төрөл" хэсгийг удирдах
          </p>
        </div>
        <button
          onClick={() => {
            resetForm();
            setShowModal(true);
          }}
          className="custom-button flex items-center space-x-2 px-6 py-3"
        >
          <FaPlus className="w-4 h-4" />
          <span>Шинэ нэмэх</span>
        </button>
      </div>

      {/* Үйлчилгээний жагсаалт */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {loading && services.length === 0 ? (
          <div className="col-span-full flex justify-center py-12">
            <div className="loading-spinner"></div>
          </div>
        ) : services.length === 0 ? (
          <div className="col-span-full text-center py-12 bg-white rounded-lg shadow">
            <div className="text-gray-400 text-5xl mb-4">
              <FaTruck />
            </div>
            <p className="text-gray-500 mb-4">Үйлчилгээ байхгүй байна</p>
            <button
              onClick={() => setShowModal(true)}
              className="custom-button"
            >
              <FaPlus className="mr-2" />
              Эхний үйлчилгээг нэмэх
            </button>
          </div>
        ) : (
          services.map((service) => (
            <div 
              key={service.id} 
              className={`bg-white rounded-lg shadow hover:shadow-lg transition p-6 relative ${
                service.is_featured ? 'ring-2 ring-green-500' : ''
              }`}
            >
              {/* Badge */}
              {service.badge_text && (
                <div className="absolute top-4 right-4 bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-full">
                  {service.badge_text}
                </div>
              )}

              {/* Icon */}
              <div className={`w-16 h-16 rounded-full ${getColorClass(service.icon_color)} text-white flex items-center justify-center text-3xl mb-4`}>
                {getIconComponent(service.icon_name)}
              </div>

              {/* Нэр */}
              <h3 className="text-xl font-bold text-gray-800 mb-2">
                {service.service_name}
              </h3>

              {/* Тайлбар */}
              {service.description && (
                <p className="text-sm text-gray-600 mb-4">
                  {service.description}
                </p>
              )}

              {/* Features */}
              <ul className="space-y-2 mb-4">
                {service.features.slice(0, 4).map((feature, idx) => (
                  <li key={idx} className="flex items-start text-sm text-gray-700">
                    <span className={`mr-2 font-bold ${getTextColorClass(service.icon_color)}`}>✓</span>
                    <span>{feature}</span>
                  </li>
                ))}
                {service.features.length > 4 && (
                  <li className="text-xs text-gray-500 italic">
                    +{service.features.length - 4} онцлог
                  </li>
                )}
              </ul>

              {/* Meta */}
              <div className="flex items-center justify-between mb-4 text-xs text-gray-500">
                <span>Дараалал: {service.display_order}</span>
                {service.is_active ? (
                  <span className="badge badge-success">Идэвхтэй</span>
                ) : (
                  <span className="badge badge-secondary">Идэвхгүй</span>
                )}
              </div>

              {/* Actions */}
              <div className="flex space-x-2">
                <button
                  className="flex-1 custom-button-secondary text-sm py-2"
                  onClick={() => handleEdit(service)}
                >
                  <FaEdit className="mr-1" />
                  Засах
                </button>
                <button
                  className="px-3 py-2 bg-red-50 text-red-600 rounded-lg hover:bg-red-100 transition"
                  onClick={() => handleDelete(service.id)}
                >
                  <FaTrash />
                </button>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content max-w-3xl">
            <div className="modal-header">
              <h3 className="text-xl font-bold text-gray-800">
                {editingService ? 'Үйлчилгээ засах' : 'Шинэ үйлчилгээ нэмэх'}
              </h3>
              <button 
                onClick={() => { setShowModal(false); resetForm(); }} 
                className="icon-button"
              >
                <FaTimes />
              </button>
            </div>

            <div className="modal-body">
              <form onSubmit={handleSubmit}>
                <div className="space-y-4">
                  {/* Үйлчилгээний нэр */}
                  <div className="form-group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Үйлчилгээний нэр <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      className="custom-input"
                      value={formData.service_name}
                      onChange={(e) => setFormData({...formData, service_name: e.target.value})}
                      required
                      placeholder="Жишээ: Экспресс тээвэр"
                    />
                  </div>

                  {/* Тайлбар */}
                  <div className="form-group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Товч тайлбар
                    </label>
                    <textarea
                      className="custom-input"
                      rows="2"
                      value={formData.description}
                      onChange={(e) => setFormData({...formData, description: e.target.value})}
                      placeholder="Жишээ: Чингэлэг тээвэр"
                    />
                  </div>

                  {/* Онцлог шинж чанарууд */}
                  <div className="form-group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Онцлог шинж чанарууд <span className="text-red-500">*</span>
                    </label>
                    <div className="space-y-2">
                      {formData.features.map((feature, index) => (
                        <div key={index} className="flex gap-2">
                          <input
                            type="text"
                            className="custom-input flex-1"
                            value={feature}
                            onChange={(e) => updateFeature(index, e.target.value)}
                            placeholder={`Онцлог ${index + 1}`}
                          />
                          <button
                            type="button"
                            onClick={() => moveFeatureUp(index)}
                            disabled={index === 0}
                            className="icon-button"
                            title="Дээш"
                          >
                            <FaArrowUp />
                          </button>
                          <button
                            type="button"
                            onClick={() => moveFeatureDown(index)}
                            disabled={index === formData.features.length - 1}
                            className="icon-button"
                            title="Доош"
                          >
                            <FaArrowDown />
                          </button>
                          <button
                            type="button"
                            onClick={() => removeFeature(index)}
                            disabled={formData.features.length === 1}
                            className="icon-button text-red-600"
                            title="Устгах"
                          >
                            <FaTrash />
                          </button>
                        </div>
                      ))}
                      <button
                        type="button"
                        onClick={addFeature}
                        className="custom-button-secondary w-full"
                      >
                        <FaPlus className="mr-2" />
                        Онцлог нэмэх
                      </button>
                    </div>
                  </div>

                  {/* Icon сонгох */}
                  <div className="form-group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Icon сонгох
                    </label>
                    <div className="grid grid-cols-4 md:grid-cols-8 gap-2">
                      {iconOptions.map((icon) => (
                        <button
                          key={icon.name}
                          type="button"
                          onClick={() => setFormData({...formData, icon_name: icon.name})}
                          className={`p-4 border-2 rounded-lg transition ${
                            formData.icon_name === icon.name
                              ? 'border-blue-500 bg-blue-50'
                              : 'border-gray-200 hover:border-gray-300'
                          }`}
                          title={icon.label}
                        >
                          <span className="text-2xl">{icon.component}</span>
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Өнгө сонгох */}
                  <div className="form-group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Өнгө сонгох
                    </label>
                    <div className="grid grid-cols-4 md:grid-cols-8 gap-2">
                      {colorOptions.map((color) => (
                        <button
                          key={color.value}
                          type="button"
                          onClick={() => setFormData({...formData, icon_color: color.value})}
                          className={`p-3 border-2 rounded-lg transition ${
                            formData.icon_color === color.value
                              ? 'border-gray-800 scale-110'
                              : 'border-gray-200 hover:border-gray-300'
                          }`}
                        >
                          <div className={`w-full h-12 rounded ${color.class} flex items-center justify-center text-white text-xl`}>
                            {getIconComponent(formData.icon_name)}
                          </div>
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Badge, Featured, Display Order */}
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div className="form-group">
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Badge текст
                      </label>
                      <input
                        type="text"
                        className="custom-input"
                        value={formData.badge_text}
                        onChange={(e) => setFormData({...formData, badge_text: e.target.value})}
                        placeholder="Түгээмэл"
                      />
                    </div>

                    <div className="form-group">
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Онцлох эсэх
                      </label>
                      <select
                        className="custom-input"
                        value={formData.is_featured ? 'true' : 'false'}
                        onChange={(e) => setFormData({...formData, is_featured: e.target.value === 'true'})}
                      >
                        <option value="false">Үгүй</option>
                        <option value="true">Тийм</option>
                      </select>
                    </div>

                    <div className="form-group">
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Дараалал
                      </label>
                      <input
                        type="number"
                        className="custom-input"
                        value={formData.display_order}
                        onChange={(e) => setFormData({...formData, display_order: parseInt(e.target.value) || 0})}
                        min="0"
                      />
                    </div>
                  </div>

                  {/* Төлөв */}
                  <div className="form-group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Төлөв
                    </label>
                    <select
                      className="custom-input"
                      value={formData.is_active ? 'true' : 'false'}
                      onChange={(e) => setFormData({...formData, is_active: e.target.value === 'true'})}
                    >
                      <option value="true">Идэвхтэй</option>
                      <option value="false">Идэвхгүй</option>
                    </select>
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    onClick={() => { setShowModal(false); resetForm(); }}
                    className="custom-button-secondary"
                    disabled={loading}
                  >
                    <FaTimes className="mr-2" />
                    Цуцлах
                  </button>
                  <button 
                    type="submit" 
                    className="custom-button-success" 
                    disabled={loading}
                  >
                    <FaSave className="mr-2" />
                    {loading ? 'Хадгалж байна...' : 'Хадгалах'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientServicesManagement;